<template>
  <v-row
    class="deal-item"
    :class="{selected: selected && active, active, shortened }">
    <v-col cols="12">
      <v-row @click="toggleSelected" class="title-block">
        <v-col cols="auto" v-if="extended && active">
          <div class="deal-checkbox">
            <input type="checkbox" :checked="selected" />
          </div>
        </v-col>
        <v-col>
          <h4>{{ deal.displayName || deal.title }}</h4>
        </v-col>
        <v-col cols="auto" v-if="archivable">
          <a @click.stop="archive" title="archive">
            <v-icon medium color="#18305A">mdi-archive</v-icon>
          </a>
        </v-col>
        <v-col cols="auto" v-if="unarchivable">
          <a @click.stop="unarchive" title="unarchive">
            <v-icon medium color="#18305A">mdi-briefcase-check-outline</v-icon>
          </a>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" lg="9">
          <div class="deal-data">
            <div class="data-item" style="min-width: 175px">
              <label>Deal Size</label>
              <span>{{ format(deal.dealRanges) || deal.finsought }}</span>
            </div>
            <div class="data-item" style="min-width: 150px; max-width: 150px;">
              <label>Country</label>
              <span>{{ deal.baseCountry || deal.country }}</span>
            </div>
            <div v-if="!shortened" class="data-item" style="min-width: 200px; max-width: 200px;">
              <label>Sector</label>
              <span>{{ deal.industrySectors || deal.sector }}</span>
            </div>
            <div class="data-item" style="min-width: 125px">
              <label>Deal Type</label>
              <span>{{ dealType }}</span>
            </div>
            <div class="data-item" style="min-width: 125px">
              <label>Financing Type</label>
              <span>{{ [deal.isDebtInvestment && 'Debt', deal.isEquityInvestment && 'Equity'].filter(t => !!t).join(' & ') || deal.purpose }}</span>
            </div>
          </div>
          <div class="description">
            <label>Description</label>
            <p class="brief">
              {{ deal.summary || deal.brief }}
            </p>
          </div>
        </v-col>
        <v-col class="materials" v-if="deal.materials && deal.materials.length && extended" cols="12" lg="3">
          <label>Materials available</label>
          <div v-for="(material, i) in deal.materials" :key="i">
            <v-icon medium color="#18305A">
              mdi-text-box-outline
            </v-icon>
            {{ material }}
          </div>
        </v-col>
      </v-row>
    </v-col>
    </v-row>
</template>

<script>
import options from '@/data/options'

export default {
  name: 'normal-deal',
  props: {
    deal: {
      type: Object,
      default: () => {}
    },
    extended: {
      type: Boolean,
      default: false
    },
    shortened: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    },
    archivable: {
      type: Boolean,
      default: false
    },
    unarchivable: {
      type: Boolean,
      default: false
    },
    dealType: {
      type: String
    }
  },
  computed: {
    options () {
      return options
    }
  },
  methods: {
    format (dealRanges) {
      return (options.dealRanges.find(d => d.value === dealRanges) || {}).name || dealRanges
    },
    toggleSelected () {
      this.$emit('toggle')
    },
    archive () {
      this.$emit('archive')
    },
    unarchive () {
      this.$emit('unarchive')
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/styles/variables.scss";
@import "@/components/deals/items/deal.scss";
</style>
